/** REST + WebSocket contract for support chat (not GraphQL). */
export class SupportChatApiError extends Error {
    status;
    body;
    /** Ops error code from the JSON body (e.g. `customer_banned`), when the backend supplies one. */
    code;
    constructor(message, status, body) {
        super(message);
        this.status = status;
        this.body = body;
        this.name = 'SupportChatApiError';
        if (body &&
            typeof body === 'object' &&
            typeof body.code === 'string') {
            this.code = body.code;
        }
    }
}
/**
 * True for the error the backend returns on the two customer write paths for a banned
 * customer: 403 for a player, 401 for a guest (guest writes are gated by session auth,
 * so a ban surfaces as an auth failure there instead of a forbidden one).
 */
export function isCustomerBannedError(e) {
    return (e instanceof SupportChatApiError &&
        (e.status === 403 || e.status === 401) &&
        e.code === 'customer_banned');
}
/**
 * Thrown client-side, before any network call, when message content exceeds the client-side
 * character cap (`SUPPORT_CHAT_MESSAGE_MAX_CHARACTERS`). A backend rejection for the same kind of
 * condition (`400 message_too_long`) carries no response body (a bare status), so it cannot be
 * distinguished from other customer 400s after the fact — this check must happen client-side to
 * give the user a specific, actionable error.
 */
export class SupportChatMessageTooLongError extends Error {
    maxCharacters;
    constructor(maxCharacters) {
        super('Message content exceeds maximum length');
        this.maxCharacters = maxCharacters;
        this.name = 'SupportChatMessageTooLongError';
    }
}
